export const GET_TPP_SETTINGS_SUCCESS = 'GET_TPP_SETTINGS_SUCCESS';
export const GET_EMAIL_TEMPLATES_SUCCESS = 'GET_EMAIL_TEMPLATES_SUCCESS';
